import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.payment');
    core.constant(
        'CURRENCY',
        Object.freeze([
            { code: 'AED', symbol: 'د.إ' },
            { code: 'AFN', symbol: '؋' },
            { code: 'ALL', symbol: 'Lek' },
            { code: 'AMD', symbol: '' },
            { code: 'ANG', symbol: 'ƒ' },
            { code: 'AOA', symbol: '' },
            { code: 'ARS', symbol: '$' },
            { code: 'AUD', symbol: '$' },
            { code: 'AWG', symbol: 'ƒ' },
            { code: 'AZN', symbol: '₼' },
            { code: 'BAM', symbol: 'KM' },
            { code: 'BBD', symbol: '$' },
            { code: 'BDT', symbol: '' },
            { code: 'BGN', symbol: 'лв' },
            { code: 'BHD', symbol: '' },
            { code: 'BIF', symbol: '' },
            { code: 'BMD', symbol: '$' },
            { code: 'BND', symbol: '$' },
            { code: 'BOB', symbol: '$b' },
            { code: 'BOV', symbol: '' },
            { code: 'BRL', symbol: 'R$' },
            { code: 'BSD', symbol: '$' },
            { code: 'BTN', symbol: '' },
            { code: 'BWP', symbol: 'P' },
            { code: 'BYN', symbol: 'Br' },
            { code: 'BZD', symbol: 'BZ$' },
            { code: 'CAD', symbol: '$' },
            { code: 'CDF', symbol: '' },
            { code: 'CHE', symbol: '' },
            { code: 'CHF', symbol: 'CHF' },
            { code: 'CHW', symbol: '' },
            { code: 'CLF', symbol: '' },
            { code: 'CLP', symbol: '$' },
            { code: 'CNY', symbol: '¥' },
            { code: 'COP', symbol: '$' },
            { code: 'COU', symbol: '' },
            { code: 'CRC', symbol: '₡' },
            { code: 'CUC', symbol: '' },
            { code: 'CUP', symbol: '₱' },
            { code: 'CVE', symbol: '' },
            { code: 'CZK', symbol: 'Kč' },
            { code: 'DJF', symbol: '' },
            { code: 'DKK', symbol: 'kr' },
            { code: 'DOP', symbol: 'RD$' },
            { code: 'DZD', symbol: '' },
            { code: 'ECS', symbol: '' },
            { code: 'ECV', symbol: '' },
            { code: 'EGP', symbol: '£' },
            { code: 'ERN', symbol: '' },
            { code: 'ETB', symbol: '' },
            { code: 'EUR', symbol: '€' },
            { code: 'FJD', symbol: '$' },
            { code: 'FKP', symbol: '£' },
            { code: 'GBP', symbol: '£' },
            { code: 'GEL', symbol: '' },
            { code: 'GHS', symbol: '¢' },
            { code: 'GIP', symbol: '£' },
            { code: 'GMD', symbol: '' },
            { code: 'GNF', symbol: '' },
            { code: 'GTQ', symbol: 'Q' },
            { code: 'GYD', symbol: '$' },
            { code: 'HKD', symbol: '$' },
            { code: 'HNL', symbol: 'L' },
            { code: 'HRK', symbol: 'kn' },
            { code: 'HTG', symbol: '' },
            { code: 'HUF', symbol: 'Ft' },
            { code: 'IDR', symbol: 'Rp' },
            { code: 'ILS', symbol: '₪' },
            { code: 'INR', symbol: '₹' },
            { code: 'IQD', symbol: '' },
            { code: 'IRR', symbol: '﷼' },
            { code: 'ISK', symbol: 'kr' },
            { code: 'JMD', symbol: 'J$' },
            { code: 'JOD', symbol: '' },
            { code: 'JPY', symbol: '¥' },
            { code: 'KES', symbol: '' },
            { code: 'KGS', symbol: 'лв' },
            { code: 'KHR', symbol: '៛' },
            { code: 'KMF', symbol: '' },
            { code: 'KPW', symbol: '' },
            { code: 'KRW', symbol: '' },
            { code: 'KZT', symbol: '' },
            { code: 'KWD', symbol: '₩' },
            { code: 'KYD', symbol: '$' },
            { code: 'LAK', symbol: '₭' },
            { code: 'LBP', symbol: '£' },
            { code: 'LKR', symbol: '₨' },
            { code: 'LRD', symbol: '$' },
            { code: 'LSL', symbol: '' },
            { code: 'LYD', symbol: '' },
            { code: 'MAD', symbol: '' },
            { code: 'MDL', symbol: '' },
            { code: 'MGA', symbol: '' },
            { code: 'MKD', symbol: 'ден' },
            { code: 'MMK', symbol: '' },
            { code: 'MNT', symbol: '₮' },
            { code: 'MOP', symbol: '' },
            { code: 'MRO', symbol: '' },
            { code: 'MUR', symbol: '₨' },
            { code: 'MVR', symbol: '' },
            { code: 'MWK', symbol: '' },
            { code: 'MXN', symbol: '$' },
            { code: 'MXV', symbol: '' },
            { code: 'MYR', symbol: 'RM' },
            { code: 'MZN', symbol: 'MT' },
            { code: 'NAD', symbol: '$' },
            { code: 'NGN', symbol: '₦' },
            { code: 'NHF', symbol: '' },
            { code: 'NIO', symbol: 'C$' },
            { code: 'NOK', symbol: 'kr' },
            { code: 'NPR', symbol: '₨' },
            { code: 'NZD', symbol: '$' },
            { code: 'OMR', symbol: '﷼' },
            { code: 'PAB', symbol: 'B/.' },
            { code: 'PEN', symbol: 'S/.' },
            { code: 'PGK', symbol: '' },
            { code: 'PHP', symbol: '₱' },
            { code: 'PKR', symbol: '₨' },
            { code: 'PLN', symbol: 'zł' },
            { code: 'PYG', symbol: 'Gs' },
            { code: 'QAR', symbol: '﷼' },
            { code: 'RON', symbol: 'lei' },
            { code: 'RSD', symbol: 'Дин.' },
            { code: 'RUB', symbol: '₽' },
            { code: 'RWF', symbol: '' },
            { code: 'SAR', symbol: '﷼' },
            { code: 'SBD', symbol: '$' },
            { code: 'SCR', symbol: '₨' },
            { code: 'SDG', symbol: '' },
            { code: 'SEK', symbol: 'kr' },
            { code: 'SGD', symbol: '$' },
            { code: 'SHP', symbol: '£' },
            { code: 'SLL', symbol: '' },
            { code: 'SOS', symbol: 'S' },
            { code: 'SRD', symbol: '$' },
            { code: 'SSP', symbol: '' },
            { code: 'STD', symbol: '' },
            { code: 'SYP', symbol: '£' },
            { code: 'SZL', symbol: '' },
            { code: 'THB', symbol: '฿' },
            { code: 'TJS', symbol: '' },
            { code: 'TMT', symbol: '' },
            { code: 'TND', symbol: '' },
            { code: 'TOP', symbol: '' },
            { code: 'TRY', symbol: '₺' },
            { code: 'TTD', symbol: 'TT$' },
            { code: 'TWD', symbol: 'NT$' },
            { code: 'TZD', symbol: '' },
            { code: 'UAH', symbol: '₴' },
            { code: 'UGX', symbol: '' },
            { code: 'USD', symbol: '$' },
            { code: 'USN', symbol: '' },
            { code: 'USS', symbol: '' },
            { code: 'UYU', symbol: '$U' },
            { code: 'UZS', symbol: 'лв' },
            { code: 'VEF', symbol: 'Bs' },
            { code: 'VND', symbol: '₫' },
            { code: 'VUV', symbol: '' },
            { code: 'WST', symbol: '' },
            { code: 'XAF', symbol: '' },
            { code: 'XAG', symbol: '' },
            { code: 'XAU', symbol: '' },
            { code: 'XCD', symbol: '$' },
            { code: 'XDR', symbol: '' },
            { code: 'XFO', symbol: '' },
            { code: 'XOF', symbol: '' },
            { code: 'XPD', symbol: '' },
            { code: 'XPF', symbol: '' },
            { code: 'XPT', symbol: '' },
            { code: 'YER', symbol: '﷼' },
            { code: 'ZAR', symbol: 'R' },
            { code: 'ZMW', symbol: '' },
            { code: 'ZWL', symbol: '' },
        ])
    );
})();
